import { useCurrentUserLevel } from "@radarly/core/user/use-cases";
import { isRoot } from "@radarly/models/level";
import { Project } from "@radarly/models/project";

function isPublicProject(project: Project) {
  return project?.flags?.isPublic;
}
export function useCanAccessProjectFromCurrentUserLevel(project: Project) {
  const level = useCurrentUserLevel();
  return isPublicProject(project) || isRoot(level);
}
